import * as React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import cx from 'classnames';

import Button from 'components/Button';
import ArrowBooking from 'components/Icons/ArrowBooking.svg';

import { useServices } from 'hooks/services/useServices';

import Home from '../../../components/Icons/Home.svg';

import s from './BookingHeader.module.css';

type TProps = {
  onBook: () => void;
  onClear: () => void;
};

export const BOOKING_HEADER_TEST_ID = 'booking-header';

export const BookingHeader = ({ onClear, onBook }: TProps) => {
  const router = useRouter();

  const { selectedServices } = useServices();

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      void router.prefetch('/book');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const count = selectedServices.length;

  return (
    <div
      className={cx(s.bookingHeader, { [s.show]: count > 0 })}
      aria-hidden={count === 0}
      data-testid={BOOKING_HEADER_TEST_ID}
    >
      <div className={s.container}>
        <div className={s.leftContainer}>
          <Link href="/" className={cx(s.btn)} title="Navigate to Home">
            <Home />
          </Link>
          <Button className={cx(s.btn, s.clearServices)} onClick={onClear}>
            Clear All
          </Button>
        </div>
        <Button onClick={onBook} className={cx(s.btnBook)}>
          Book {count} {count > 1 ? 'services' : 'service'}{' '}
          <ArrowBooking className="icon-arrow-right" />
        </Button>
      </div>
    </div>
  );
};
